<div class="main">
  <div class="header">
    <div  class="text">
      {{ 'PAYMENT_VOUCHER_CREATE.title' | translate}}
    </div>
    <i class="material-icons" (click)="closeModal();">clear</i>
  </div>
  <div class="section">
      <div class="form">
          <div class="formElement">
              <div class="formLabel">
                {{'PAYMENT_VOUCHER_CREATE.date_of_payment' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
              </div>
              <div class="formInput">
                  <input type="text" class="dateSelect" [(ngModel)]="dates.paymentDate" [matDatepicker]="date_of_payment"  (click)="date_of_payment.open()"/>
                  <mat-datepicker #date_of_payment (closed)="setDateOfPayment(dates)"></mat-datepicker>
                  <i class="material-icons calendar">date_range</i>
              </div>
          </div>
          <div class="formElement">
              <div class="formLabel">
                {{'PAYMENT_VOUCHER_CREATE.creation_date' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
              </div>
              <div class="formInput">
                  <input type="text" class="dateSelect" [(ngModel)]="dates.creationDate" [matDatepicker]="creation_date"  (click)="creation_date.open()"/>
                  <mat-datepicker #creation_date (closed)="setCreationDate(dates)"></mat-datepicker>
                  <i class="material-icons calendar">date_range</i>
              </div>
          </div>
          <div class="formElement">
              <div class="formLabel">
                {{'PAYMENT_VOUCHER_CREATE.payee' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
              </div>
              <div class="formInput">
                <input class="form-input" [(ngModel)]="createData.payee" type="text"/>
              </div>
          </div>
          <div class="formElement">
              <div class="formLabel">
                {{'PAYMENT_VOUCHER_CREATE.shipment_no' | translate}}
              </div>
              <div class="formInput">
                <input class="form-input" [(ngModel)]="createData.shipment_no" type="text"/>
              </div>
          </div>
          <div class="formElement">
              <div class="formLabel">
                {{'PAYMENT_VOUCHER_CREATE.driver_name' | translate}}
              </div>
              <div class="formInput">
                <input class="form-input" [(ngModel)]="createData.driver_name" type="text"/>
              </div>
          </div>
          <div class="formElement">
              <div class="formLabel">
                {{'PAYMENT_VOUCHER_CREATE.vehicle_no' | translate}}
              </div>
              <div class="formInput">
                <input class="form-input" [(ngModel)]="createData.vehicle_no" type="text"/>
              </div>
          </div>
          <div class="formElement">
              <div class="formLabel">
                {{'PAYMENT_VOUCHER_CREATE.debit' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
              </div>
              <div class="formInput">
                <input class="form-input" [(ngModel)]="createData.debit" type="text"/>
              </div>
          </div>
          <div class="formElement">
              <div class="formLabel">
                {{'PAYMENT_VOUCHER_CREATE.credit' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
              </div>
              <div class="formInput">
                <input class="form-input" [(ngModel)]="createData.credit" type="text"/>
              </div>
          </div>
          <div class="formElement">
              <div class="formLabel">
                {{'PAYMENT_VOUCHER_CREATE.type' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
              </div>
              <mat-select class="inputSelect" style="color: #fff;">
                  <mat-option *ngFor="let type of types" [value]="type"(click)="selectType(type)">
                    {{type.name}}
                  </mat-option>
              </mat-select>
          </div>
          <div class="formElement" *ngIf="createData.type != 'CASH'">
              <div class="formLabel">
                {{'PAYMENT_VOUCHER_CREATE.name_of_bank' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
              </div>
              <div class="formInput">
                <input class="form-input" [(ngModel)]="createData.bank_details.name" type="text"/>
              </div>
          </div>
          <div class="formElement" *ngIf="createData.type != 'CASH'">
              <div class="formLabel">
                {{'PAYMENT_VOUCHER_CREATE.account_no' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
              </div>
              <div class="formInput">
                <input class="form-input" [(ngModel)]="createData.bank_details.acc_no" type="text"/>
              </div>
          </div>
          <div class="formElement" *ngIf="createData.type != 'CASH'">
              <div class="formLabel">
                {{'PAYMENT_VOUCHER_CREATE.ifsc' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
              </div>
              <div class="formInput">
                <input class="form-input" [(ngModel)]="createData.bank_details.fsc" type="text"/>
              </div>
          </div>
          <div class="formElement" *ngIf="createData.type != 'CASH'">
              <div class="formLabel">
                {{'PAYMENT_VOUCHER_CREATE.cheque_no' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
              </div>
              <div class="formInput">
                <input class="form-input" [(ngModel)]="createData.bank_details.doc_no" type="text"/>
              </div>
          </div>
          <div class="formElement">
              <div class="formLabel">
                {{'PAYMENT_VOUCHER_CREATE.amount' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
              </div>
              <div class="formInput">
                <input class="form-input" [(ngModel)]="createData.amount" type="text"/>
              </div>
          </div>
          <div class="formElement">
              <div class="formLabel">
                {{'PAYMENT_VOUCHER_CREATE.narration' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
              </div>
              <div class="formInput">
                <textarea class="form-input" style="height: 60px;" rows="30" [(ngModel)]="createData.narration" type="text"></textarea>
              </div>
          </div>
          <br/>
      </div>

      <div class="submitButton" (click)="createPaymentVoucher();" >
          <div class="button">
          {{'PAYMENT_VOUCHER_CREATE.submit' | translate}}
          </div>
      </div>
  </div>
</div>
